import { ONBOARDING_STEPS } from '../../../../../utils/constants';
import { FormValues } from '../../../../../types';

export function getText(values: FormValues | undefined, option: any, index: number): string | null {
  let text = null;

  switch (index) {
    case 0:
      text = option;
      break;
    case 1: {
      const isBridge = (
        values?.[ONBOARDING_STEPS[1].text] === ONBOARDING_STEPS[1].options[0].text
        && values?.[ONBOARDING_STEPS[2].text] === ONBOARDING_STEPS[2].options[0].text
      );
      const isRental = (
        values?.[ONBOARDING_STEPS[1].text] === ONBOARDING_STEPS[1].options[0].text
        && values?.[ONBOARDING_STEPS[2].text] === ONBOARDING_STEPS[2].options[1].text
      );
      const isFix = (
        values?.[ONBOARDING_STEPS[1].text] === ONBOARDING_STEPS[1].options[1].text
        && values?.[ONBOARDING_STEPS[2].text] === ONBOARDING_STEPS[2].options[0].text
      );

      if (isBridge) {
        text = '12-month bridge';
      } else if (isRental) {
        text = '30-year rental';
      } else if (isFix) {
        text = '12-month fix-and-flip';
      } else {
        text = 'bridge or rental';
      }
      break;
    }
    case 2:
      text = (
        [
          '12-month',
          '30-year',
        ][ONBOARDING_STEPS[2].options.findIndex((item: any) => item.text === option)]
      );
      break;
    case 3: {
      const optionIndex = ONBOARDING_STEPS[3].options.findIndex((stepOption: any) => {
        if (stepOption.text === option) {
          return true;
        }
        if ('label' in stepOption && stepOption.label === option) {
          return true;
        }
        return false;
      });
      if (optionIndex >= 0) {
        text = (
          [
            'purchase',
            'refinance',
          ][optionIndex]
        );
      }
      break;
    }
    case 4:
      text = (
        [
          'single-family home',
          '2-4 unit property',
          'portfolio',
          'warrantable condo',
          'non-warrantable condo',
          '5-20 unit property',
          'mixed-use property',
        ][ONBOARDING_STEPS[4].options.findIndex((item: any) => item.text === option)]
      );
      break;
    case 5:
      text = (
        [
          'less than 660',
          '660-679',
          '680-699',
          '700-719',
          '720-739',
          '740-759',
          '760-779',
          '780+',
        ][ONBOARDING_STEPS[5].options.findIndex((item: any) => item.text === option)]
      );
      break;
    case 6:
      text = (
        [
          '0 properties',
          '1-2 properties',
          '3-7 properties',
          '8+ properties',
        ][ONBOARDING_STEPS[6].options.findIndex((item: any) => item.text === option)]
      );
      break;
  }

  return text;
}

